"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_BLOCK_LAYER_PROPERTY_KEYS = exports.PageLayerIndexError = void 0;
exports.pageCanvasLayerBounds = pageCanvasLayerBounds;
exports.pageEntryCanvasLayer = pageEntryCanvasLayer;
exports.pageBlockInCanvasLayer = pageBlockInCanvasLayer;
exports.pageBlockUsesLayer = pageBlockUsesLayer;
const page_structure_entry_1 = require("./page-structure-entry");
const page_structure_tree_1 = require("./page-structure-tree");
const system_managed_visibility_1 = require("./system-managed-visibility");
class PageLayerIndexError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'PageLayerIndexError';
    }
}
exports.PageLayerIndexError = PageLayerIndexError;
/** Only the head is read, including objects whose content parts are not loaded. */
function pageCanvasLayerBounds(entries) {
    let first = null, last = null;
    for (const [id, entry] of entries) {
        const layer = pageEntryCanvasLayer(id, entry, entries);
        if (layer instanceof PageLayerIndexError)
            throw layer;
        if (layer === null)
            continue;
        if (first === null || layer < first)
            first = layer;
        if (last === null || layer > last)
            last = layer;
    }
    return { first, last };
}
/**
 * The canvas layer one entry adds to the bounds of its page: null without
 * one, the error of a missing or invalid layer instead of throwing it.
 */
function pageEntryCanvasLayer(id, entry, entries) {
    if (!(0, page_structure_tree_1.isPageTreeEntry)(entry) || entry.d !== undefined)
        return null;
    const element = (0, page_structure_entry_1.isPageElementKind)(entry.k);
    const parentKind = entry.p === null ? undefined : entries.get(entry.p)?.k;
    const needsLayer = pageBlockInCanvasLayer(entry.k, parentKind);
    const layer = element ? entry.o : entry.l;
    if (needsLayer && layer === undefined)
        return new PageLayerIndexError('Missing canvas layer: ' + id);
    if (layer === null || layer === undefined)
        return null;
    if (!(0, page_structure_entry_1.isFractionalIndex)(layer))
        return new PageLayerIndexError('Invalid canvas layer: ' + id);
    return layer;
}
function pageBlockInCanvasLayer(kind, parentKind) {
    return (!(0, page_structure_entry_1.isPageElementKind)(kind) &&
        kind !== 'affine:surface' &&
        (parentKind === 'affine:page' || parentKind === 'affine:surface'));
}
/**
 * A block in the canvas layer position has a layer exactly when it has a
 * place on the canvas (prop:xywh) and is no hidden system database; any
 * other gets l = null. Canvas blocks have a layer independently of their
 * position in the page tree.
 */
function pageBlockUsesLayer(id, kind, parentKind, values) {
    return (pageBlockInCanvasLayer(kind, parentKind) &&
        values.xywh !== undefined &&
        !(kind === 'affine:database' &&
            (0, system_managed_visibility_1.isHiddenSystemManagedDatabase)({
                id,
                managedBy: values.managedBy,
                visible: values.visible,
            })));
}
exports.PAGE_BLOCK_LAYER_PROPERTY_KEYS = [
    'index',
    'managedBy',
    'visible',
    'xywh',
];
